import React from "react";

const Modal: React.FC<{
  isOpen: boolean;
  children: React.ReactNode;
}> = ({ isOpen, children }) => {
  const animationContainerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (isOpen && animationContainerRef.current) {
      setTimeout(() => {
        if (animationContainerRef.current) {
          animationContainerRef.current.style.opacity = "1";
        }
      }, 50);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div style={modalStyles.overlay}>
      <div
        id="onboarding-advertise-v4__modal-container"
        ref={animationContainerRef}
        style={modalStyles.container}
      >
        {children}
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  container: {
    backgroundColor: "white",
    padding: "15px 30px",
    borderRadius: "20px",
    overflow: "auto",
    border: "1px solid #C4C6CD",
    boxSizing: "border-box",
  },
} as const;

export default Modal;
